import { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import UserTable from '../../components/admin/UserTable';
import UserSubscriptionModal from '../../components/admin/UserSubscriptionModal';
import axios from 'axios';
import './AdminStyles.css';

// Используем относительный путь для админ панели
const API_URL = '/api';

function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  
  // State для модального окна
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, [page]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('admin_token');
      
      const response = await axios.get(`${API_URL}/admin/users?page=${page}&limit=50`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsers(response.data.users);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch users:', err);
      setError('Не удалось загрузить пользователей');
    } finally {
      setLoading(false);
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handleModalUpdate = () => {
    // Обновляем список пользователей после изменений
    fetchUsers();
  };

  return (
    <AdminLayout currentPage="users">
      <div className="admin-page">
        <div style={{ marginBottom: '32px' }}>
          <h1 className="text-3xl font-bold text-gray-900" style={{ marginBottom: '8px' }}>Пользователи</h1>
          <p className="text-gray-500">Список всех пользователей платформы. Нажмите на пользователя для управления подписками.</p>
        </div>

        <div className="admin-table">
          {error ? (
            <div className="empty-state">
              <p className="empty-state-title text-red-500">{error}</p>
              <button onClick={fetchUsers} className="admin-button admin-button-primary" style={{ marginTop: '16px' }}>
                Повторить
              </button>
            </div>
          ) : (
            <UserTable users={users} loading={loading} onUserClick={handleUserClick} />
          )}
        </div>
      </div>

      {isModalOpen && selectedUser && (
        <UserSubscriptionModal
          userId={selectedUser.id}
          user={selectedUser}
          onClose={handleCloseModal}
          onUpdate={handleModalUpdate}
        />
      )}
    </AdminLayout>
  );
}

export default AdminUsersPage;

